import { createContext } from "react";

/** The flyout's footer element, which sections render their actions into. */
export const FlyoutFooterContext = createContext<HTMLElement | null>(null);
